import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-visits',
  // standalone: true,
  // imports: [],
  templateUrl: './visits.component.html',
  styleUrl: './visits.component.scss'
})
export class VisitsComponent {


  queryParams: any = {}; // To store query parameter data
  studyDetails: any = {};

  // subjectId: string;
  groupedStudies: any[];

  Name: string;
  name: string = '';
  studyId: any = '';
  centers: string = '';
  subjectId : string= '';

  
  folderForm: any;

  selectedForm: string;
  selectedFieldType: string = 'string'; // Default selected type

  selectedFolder: string | null = null;

  formData = {
    showDateField: '', // Default value for dropdown
    selectedDate: '', // Holds the date value if the user selects Yes
  };

    // Sample data
    data = [
      { sr: 1, name: 'Daytime mood', score: '' },
      { sr: 2, name: 'Ability to function at work', score: '' },
      { sr: 3, name: 'Concentration', score: '' },

      { sr: 4, name: 'Relaxation', score: '' },
      { sr: 5, name: 'Sound sleep', score: '' },
      { sr: 6, name: 'Freshness', score: '' },
      { sr: 7, name: 'Racing Thoughts', score: '' },
      { sr: 8, name: 'Day time drowsiness', score: '' },
      { sr: 9, name: 'Grogginess/Brain Fog', score: '' }

    ];


    
 // Legend for scores
 scoreLegend = [
  { value: 1, description: 'Average' },
  { value: 2, description: 'Good' },
  { value: 3, description: 'Very Good' },
  { value: 4, description: 'Excellent' },
  { value: 5, description: 'Outstanding' },
];


  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,private apiService: ApiService,
    private router: Router,
  ){

    this.folderForm = this.fb.group({
      Name: ['', Validators.required],
      
    });

  }
  

  ngOnInit(): void {
    // Retrieve query parameters
    // this.route.queryParamMap.subscribe(params => {
    //   this.name = params.get('name') || '';
    //   this.studyId = params.get('studyId') || '';
    //   this.centers = params.get('centers') || '';
    // });

 // Retrieve query parameters after component initializes
 this.route.queryParamMap.subscribe(params => {
  // this.queryParams.name = params.get('name');
  this.queryParams.studyId = params.get('studyId');
  this.queryParams.name = params.get('name');
  this.queryParams.centers = params.get('centers');
  // this.queryParams.subjectId = params.get('sujectId'); // Correctly named field in query parameters

  this.queryParams.subjectId = params.get('subjectId'); // Correct field name

  console.log('visit folders  Details here :', this.queryParams);

  console.log('subjectId here', this.queryParams.subjectId);

});
}





isScreeningVisible: boolean = false;

toggleScreening() {
  this.isScreeningVisible = !this.isScreeningVisible; // Toggle visibility
}


showForm(formName: string) {
  this.selectedForm = formName; // e.g., 'assessment1'
}


 // Method to set the selected folder
 selectFolder(folderName: string): void {
  this.selectedFolder = folderName;
}

 // Method to handle folder click
 onFolderClick(folderName: string): void {
  this.selectedFolder = folderName;
  this.toggleScreening(); // Toggle visibility for Screening Visit sub-items
}

// Method to handle sub-item click
onSubItemClick(subItemName: string, formName: string): void {
  this.selectedFolder = subItemName;
  this.showForm(formName); // Open the appropriate form
}



onSubClick(subItemName: string, formName: string): void {
  this.selectedFolder = subItemName;
  // this.showForm(formName); // Open the appropriate form

}


selectedItem: string = ''; // Holds the currently selected item
// Method to set the selected item
selectItem(item: string): void {
  this.selectedItem = item;
  console.log('Selected item:', this.selectedItem); // Debugging
}



goBack(){
  this.router.navigate(['/folders']);
}



}
